const countries = [
  { name: 'Afghanistan', code: 'AF', dial_code: '+93' },
  { name: 'Åland Islands', code: 'AX', dial_code: '+358' },
  { name: 'Albania', code: 'AL', dial_code: '+355' },
  { name: 'Algeria', code: 'DZ', dial_code: '+213' },
  { name: 'American Samoa', code: 'AS', dial_code: '+1684' },
  { name: 'Andorra', code: 'AD', dial_code: '+376' },
  { name: 'Angola', code: 'AO', dial_code: '+244' },
  { name: 'Anguilla', code: 'AI', dial_code: '+1264' },
  { name: 'Antarctica', code: 'AQ', dial_code: '+672' },
  { name: 'Antigua and Barbuda', code: 'AG', dial_code: '+1268' },
  { name: 'Argentina', code: 'AR', dial_code: '+54' },
  { name: 'Armenia', code: 'AM', dial_code: '+374' },
  { name: 'Aruba', code: 'AW', dial_code: '+297' },
  { name: 'Australia', code: 'AU', dial_code: '+61' },
  { name: 'Austria', code: 'AT', dial_code: '+43' },
  { name: 'Azerbaijan', code: 'AZ', dial_code: '+994' },
  { name: 'Bahamas', code: 'BS', dial_code: '+1242' },
  { name: 'Bahrain', code: 'BH', dial_code: '+973' },
  { name: 'Bangladesh', code: 'BD', dial_code: '+880' },
  { name: 'Barbados', code: 'BB', dial_code: '+1246' },
  { name: 'Belarus', code: 'BY', dial_code: '+375' },
  { name: 'Belgium', code: 'BE', dial_code: '+32' },
  { name: 'Belize', code: 'BZ', dial_code: '+501' },
  { name: 'Benin', code: 'BJ', dial_code: '+229' },
  { name: 'Bermuda', code: 'BM', dial_code: '+1441' },
  { name: 'Bhutan', code: 'BT', dial_code: '+975' },
  { name: 'Bolivia', code: 'BO', dial_code: '+591' },
  { name: 'Bosnia and Herzegovina', code: 'BA', dial_code: '+387' },
  { name: 'Botswana', code: 'BW', dial_code: '+267' },
  { name: 'Brazil', code: 'BR', dial_code: '+55' },
  { name: 'British Indian Ocean Territory', code: 'IO', dial_code: '+246' },
  { name: 'Brunei Darussalam', code: 'BN', dial_code: '+673' },
  { name: 'Bulgaria', code: 'BG', dial_code: '+359' },
  { name: 'Burkina Faso', code: 'BF', dial_code: '+226' },
  { name: 'Burundi', code: 'BI', dial_code: '+257' },
  { name: 'Cambodia', code: 'KH', dial_code: '+855' },
  { name: 'Cameroon', code: 'CM', dial_code: '+237' },
  { name: 'Canada', code: 'CA', dial_code: '+1' },
  { name: 'Cape Verde', code: 'CV', dial_code: '+238' },
  { name: 'Cayman Islands', code: 'KY', dial_code: '+1345' },
  { name: 'Central African Republic', code: 'CF', dial_code: '+236' },
  { name: 'Chad', code: 'TD', dial_code: '+235' },
  { name: 'Chile', code: 'CL', dial_code: '+56' },
  { name: 'China', code: 'CN', dial_code: '+86' },
  { name: 'Christmas Island', code: 'CX', dial_code: '+61' },
  { name: 'Cocos (Keeling) Islands', code: 'CC', dial_code: '+61' },
  { name: 'Colombia', code: 'CO', dial_code: '+57' },
  { name: 'Comoros', code: 'KM', dial_code: '+269' },
  { name: 'Congo', code: 'CG', dial_code: '+242' },
  { name: 'Congo, Democratic Republic of the', code: 'CD', dial_code: '+243' },
  { name: 'Cook Islands', code: 'CK', dial_code: '+682' },
  { name: 'Costa Rica', code: 'CR', dial_code: '+506' },
  { name: 'Croatia', code: 'HR', dial_code: '+385' },
  { name: 'Cuba', code: 'CU', dial_code: '+53' },
  { name: 'Cyprus', code: 'CY', dial_code: '+357' },
  { name: 'Czech Republic', code: 'CZ', dial_code: '+420' },
  { name: 'Denmark', code: 'DK', dial_code: '+45' },
  { name: 'Djibouti', code: 'DJ', dial_code: '+253' },
  { name: 'Dominica', code: 'DM', dial_code: '+1767' },
  { name: 'Dominican Republic', code: 'DO', dial_code: '+1‑809, +1‑829, +1‑849' },
  { name: 'Ecuador', code: 'EC', dial_code: '+593' },
  { name: 'Egypt', code: 'EG', dial_code: '+20' },
  { name: 'El Salvador', code: 'SV', dial_code: '+503' },
  { name: 'Equatorial Guinea', code: 'GQ', dial_code: '+240' },
  { name: 'Eritrea', code: 'ER', dial_code: '+291' },
  { name: 'Estonia', code: 'EE', dial_code: '+372' },
  { name: 'Ethiopia', code: 'ET', dial_code: '+251' },
  { name: 'Falkland Islands', code: 'FK', dial_code: '+500' },
  { name: 'Faroe Islands', code: 'FO', dial_code: '+298' },
  { name: 'Fiji', code: 'FJ', dial_code: '+679' },
  { name: 'Finland', code: 'FI', dial_code: '+358' },
  { name: 'France', code: 'FR', dial_code: '+33' },
  { name: 'French Guiana', code: 'GF', dial_code: '+594' },
  { name: 'French Polynesia', code: 'PF', dial_code: '+689' },
  { name: 'Gabon', code: 'GA', dial_code: '+241' },
  { name: 'Gambia', code: 'GM', dial_code: '+220' },
  { name: 'Georgia', code: 'GE', dial_code: '+995' },
  { name: 'Germany', code: 'DE', dial_code: '+49' },
  { name: 'Ghana', code: 'GH', dial_code: '+233' },
  { name: 'Gibraltar', code: 'GI', dial_code: '+350' },
  { name: 'Greece', code: 'GR', dial_code: '+30' },
  { name: 'Greenland', code: 'GL', dial_code: '+299' },
  { name: 'Grenada', code: 'GD', dial_code: '+1473' },
  { name: 'Guadeloupe', code: 'GP', dial_code: '+590' },
  { name: 'Guam', code: 'GU', dial_code: '+1671' },
  { name: 'Guatemala', code: 'GT', dial_code: '+502' },
  { name: 'Guinea', code: 'GN', dial_code: '+224' },
  { name: 'Guinea-Bissau', code: 'GW', dial_code: '+245' },
  { name: 'Guyana', code: 'GY', dial_code: '+592' },
  { name: 'Haiti', code: 'HT', dial_code: '+509' },
  { name: 'Holy See (Vatican City State)', code: 'VA', dial_code: '+379' },
  { name: 'Honduras', code: 'HN', dial_code: '+504' },
  { name: 'Hong Kong', code: 'HK', dial_code: '+852' },
  { name: 'Hungary', code: 'HU', dial_code: '+36' },
  { name: 'Iceland', code: 'IS', dial_code: '+354' },
  { name: 'India', code: 'IN', dial_code: '+91' },
  { name: 'Indonesia', code: 'ID', dial_code: '+62' },
  { name: 'Iran', code: 'IR', dial_code: '+98' },
  { name: 'Iraq', code: 'IQ', dial_code: '+964' },
  { name: 'Ireland', code: 'IE', dial_code: '+353' },
  { name: 'Israel', code: 'IL', dial_code: '+972' },
  { name: 'Italy', code: 'IT', dial_code: '+39' },
  { name: 'Jamaica', code: 'JM', dial_code: '+1876' },
  { name: 'Japan', code: 'JP', dial_code: '+81' },
  { name: 'Jordan', code: 'JO', dial_code: '+962' },
  { name: 'Kazakhstan', code: 'KZ', dial_code: '+7' },
  { name: 'Kenya', code: 'KE', dial_code: '+254' },
  { name: 'Kiribati', code: 'KI', dial_code: '+686' },
  { name: 'Korea, North', code: 'KP', dial_code: '+850' },
  { name: 'Korea, South', code: 'KR', dial_code: '+82' },
  { name: 'Kuwait', code: 'KW', dial_code: '+965' },
  { name: 'Kyrgyzstan', code: 'KG', dial_code: '+996' },
  { name: 'Laos', code: 'LA', dial_code: '+856' },
  { name: 'Latvia', code: 'LV', dial_code: '+371' },
  { name: 'Lebanon', code: 'LB', dial_code: '+961' },
  { name: 'Lesotho', code: 'LS', dial_code: '+266' },
  { name: 'Liberia', code: 'LR', dial_code: '+231' },
  { name: 'Libya', code: 'LY', dial_code: '+218' },
  { name: 'Liechtenstein', code: 'LI', dial_code: '+423' },
  { name: 'Lithuania', code: 'LT', dial_code: '+370' },
  { name: 'Luxembourg', code: 'LU', dial_code: '+352' },
  { name: 'Macao', code: 'MO', dial_code: '+853' },
  { name: 'North Macedonia', code: 'MK', dial_code: '+389' },
  { name: 'Madagascar', code: 'MG', dial_code: '+261' },
  { name: 'Malawi', code: 'MW', dial_code: '+265' },
  { name: 'Malaysia', code: 'MY', dial_code: '+60' },
  { name: 'Maldives', code: 'MV', dial_code: '+960' },
  { name: 'Mali', code: 'ML', dial_code: '+223' },
  { name: 'Malta', code: 'MT', dial_code: '+356' },
{
name: "Marshall Islands",
dial_code: "+692",
code: "MH"
},
{
name: "Martinique",
dial_code: "+596",
code: "MQ"
},
{
name: "Mauritania",
dial_code: "+222",
code: "MR"
},
{
name: "Mauritius",
dial_code: "+230",
code: "MU"
},
{
name: "Mayotte",
dial_code: "+262",
code: "YT"
},
{
name: "Mexico",
dial_code: "+52",
code: "MX"
},
{
name: "Micronesia, Federated States of Micronesia",
dial_code: "+691",
code: "FM"
},
{
name: "Moldova",
dial_code: "+373",
code: "MD"
},
{
name: "Monaco",
dial_code: "+377",
code: "MC"
},
{
name: "Mongolia",
dial_code: "+976",
code: "MN"
},
{
name: "Montenegro",
dial_code: "+382",
code: "ME"
},
{
name: "Montserrat",
dial_code: "+1664",
code: "MS"
},
{
name: "Morocco",
dial_code: "+212",
code: "MA"
},
{
name: "Mozambique",
dial_code: "+258",
code: "MZ"
},
{
name: "Myanmar",
dial_code: "+95",
code: "MM"
},
{
name: "Namibia",
dial_code: "+264",
code: "NA"
},
{
name: "Nauru",
dial_code: "+674",
code: "NR"
},
{
name: "Nepal",
dial_code: "+977",
code: "NP"
},
{
name: "Netherlands",
dial_code: "+31",
code: "NL"
},
{
name: "Netherlands Antilles",
dial_code: "+599",
code: "AN"
},
{
name: "New Caledonia",
dial_code: "+687",
code: "NC"
},
{
name: "New Zealand",
dial_code: "+64",
code: "NZ"
},
{
name: "Nicaragua",
dial_code: "+505",
code: "NI"
},
{
name: "Niger",
dial_code: "+227",
code: "NE"
},
{
name: "Nigeria",
dial_code: "+234",
code: "NG"
},
{
name: "Niue",
dial_code: "+683",
code: "NU"
},
{
name: "Norfolk Island",
dial_code: "+672",
code: "NF"
},
{
name: "Northern Mariana Islands",
dial_code: "+1670",
code: "MP"
},
{
name: "Norway",
dial_code: "+47",
code: "NO"
},
{
name: "Oman",
dial_code: "+968",
code: "OM"
},
{
name: "Pakistan",
dial_code: "+92",
code: "PK"
},
{
name: "Palau",
dial_code: "+680",
code: "PW"
},
{
name: "Palestinian Territory, Occupied",
dial_code: "+970",
code: "PS"
},
{
name: "Panama",
dial_code: "+507",
code: "PA"
},
{
name: "Papua New Guinea",
dial_code: "+675",
code: "PG"
},
{
name: "Paraguay",
dial_code: "+595",
code: "PY"
},
{
name: "Peru",
dial_code: "+51",
code: "PE"
},
{
name: "Philippines",
dial_code: "+63",
code: "PH"
},
{
name: "Pitcairn",
dial_code: "+872",
code: "PN"
},
{
name: "Poland",
dial_code: "+48",
code: "PL"
},
{
name: "Portugal",
dial_code: "+351",
code: "PT"
},
{
name: "Puerto Rico",
dial_code: "+1939",
code: "PR"
},
{
name: "Qatar",
dial_code: "+974",
code: "QA"
},
{
name: "Romania",
dial_code: "+40",
code: "RO"
},
{
name: "Russia",
dial_code: "+7",
code: "RU"
},
{
name: "Rwanda",
dial_code: "+250",
code: "RW"
},
{
name: "Reunion",
dial_code: "+262",
code: "RE"
},
{
name: "Saint Barthelemy",
dial_code: "+590",
code: "BL"
},
{
name: "Saint Helena, Ascension and Tristan Da Cunha",
dial_code: "+290",
code: "SH"
},
{
name: "Saint Kitts and Nevis",
dial_code: "+1869",
code: "KN"
},
{
name: "Saint Lucia",
dial_code: "+1758",
code: "LC"
},
{
name: "Saint Martin",
dial_code: "+590",
code: "MF"
},
{
name: "Saint Pierre and Miquelon",
dial_code: "+508",
code: "PM"
},
{
name: "Saint Vincent and the Grenadines",
dial_code: "+1784",
code: "VC"
},
{
name: "Samoa",
dial_code: "+685",
code: "WS"
},
{
name: "San Marino",
dial_code: "+378",
code: "SM"
},
{
name: "Sao Tome and Principe",
dial_code: "+239",
code: "ST"
},
{
name: "Saudi Arabia",
dial_code: "+966",
code: "SA"
},
{
name: "Senegal",
dial_code: "+221",
code: "SN"
},
{
name: "Serbia",
dial_code: "+381",
code: "RS"
},
{
name: "Seychelles",
dial_code: "+248",
code: "SC"
},
{
name: "Sierra Leone",
dial_code: "+232",
code: "SL"
},
{
name: "Singapore",
dial_code: "+65",
code: "SG"
},
{
name: "Slovakia",
dial_code: "+421",
code: "SK"
},
{
name: "Slovenia",
dial_code: "+386",
code: "SI"
},
{
name: "Solomon Islands",
dial_code: "+677",
code: "SB"
},
{
name: "Somalia",
dial_code: "+252",
code: "SO"
},
{
name: "South Africa",
dial_code: "+27",
code: "ZA"
},
{
name: "South Sudan",
dial_code: "+211",
code: "SS"
},
{
name: "South Georgia and the South Sandwich Islands",
dial_code: "+500",
code: "GS"
},
{
name: "Spain",
dial_code: "+34",
code: "ES"
},
{
name: "Sri Lanka",
dial_code: "+94",
code: "LK"
},
{
name: "Sudan",
dial_code: "+249",
code: "SD"
},
{
name: "Suriname",
dial_code: "+597",
code: "SR"
},
{
name: "Svalbard and Jan Mayen",
dial_code: "+47",
code: "SJ"
},
{
name: "Swaziland",
dial_code: "+268",
code: "SZ"
},
{
name: "Sweden",
dial_code: "+46",
code: "SE"
},
{
name: "Switzerland",
dial_code: "+41",
code: "CH"
},
{
name: "Syrian Arab Republic",
dial_code: "+963",
code: "SY"
},
{
name: "Taiwan",
dial_code: "+886",
code: "TW"
},
{
name: "Tajikistan",
dial_code: "+992",
code: "TJ"
},
{
name: "Tanzania, United Republic of Tanzania",
dial_code: "+255",
code: "TZ"
},
{
name: "Thailand",
dial_code: "+66",
code: "TH"
},
{
name: "Timor-Leste",
dial_code: "+670",
code: "TL"
},
{
name: "Togo",
dial_code: "+228",
code: "TG"
},
{
name: "Tokelau",
dial_code: "+690",
code: "TK"
},
{
name: "Tonga",
dial_code: "+676",
code: "TO"
},
{
name: "Trinidad and Tobago",
dial_code: "+1868",
code: "TT"
},
{
name: "Tunisia",
dial_code: "+216",
code: "TN"
},
{
name: "Turkey",
dial_code: "+90",
code: "TR"
},
{
name: "Turkmenistan",
dial_code: "+993",
code: "TM"
},
{
name: "Turks and Caicos Islands",
dial_code: "+1649",
code: "TC"
},
{
name: "Tuvalu",
dial_code: "+688",
code: "TV"
},
{
name: "Uganda",
dial_code: "+256",
code: "UG"
},
{
name: "Ukraine",
dial_code: "+380",
code: "UA"
},
{
name: "United Arab Emirates",
dial_code: "+971",
code: "AE"
},
{
name: "United Kingdom",
dial_code: "+44",
code: "GB"
},
{
name: "United States",
dial_code: "+1",
code: "US"
},
{
name: "Uruguay",
dial_code: "+598",
code: "UY"
},
{
name: "Uzbekistan",
dial_code: "+998",
code: "UZ"
},
{
name: "Vanuatu",
dial_code: "+678",
code: "VU"
},
{
name: "Venezuela, Bolivarian Republic of Venezuela",
dial_code: "+58",
code: "VE"
},
{
name: "Vietnam",
dial_code: "+84",
code: "VN"
},
{
name: "Virgin Islands, British",
dial_code: "+1284",
code: "VG"
},
{
name: "Virgin Islands, U.S.",
dial_code: "+1340",
code: "VI"
},
{
name: "Wallis and Futuna",
dial_code: "+681",
code: "WF"
},
{
name: "Yemen",
dial_code: "+967",
code: "YE"
},
{
name: "Zambia",
dial_code: "+260",
code: "ZM"
},
{
name: "Zimbabwe",
dial_code: "+263",
code: "ZW"
}
];

export default countries;

const timezoneToCountryCode = {
    'Africa/Abidjan': 'CI',
    'Africa/Accra': 'GH',
    'Africa/Addis_Ababa': 'ET',
    'Africa/Algiers': 'DZ',
    'Africa/Cairo': 'EG',
    'Africa/Johannesburg': 'ZA',
    'Africa/Lagos': 'NG',
    'America/Anchorage': 'US',
    'America/Argentina/Buenos_Aires': 'AR',
    'America/Asuncion': 'PY',
    'America/Bogota': 'CO',
    'America/Caracas': 'VE',
    'America/Chicago': 'US',
    'America/Denver': 'US',
    'America/Halifax': 'CA',
    'America/Havana': 'CU',
    'America/La_Paz': 'BO',
    'America/Lima': 'PE',
    'America/Los_Angeles': 'US',
    'America/Mexico_City': 'MX',
    'America/New_York': 'US',
    'America/Noronha': 'BR',
    'America/Phoenix': 'US',
    'America/Santiago': 'CL',
    'America/Sao_Paulo': 'BR',
    'America/St_Johns': 'CA',
    'America/Toronto': 'CA',
    'Antarctica/Casey': 'AQ',
    'Antarctica/McMurdo': 'AQ',
    'Asia/Baghdad': 'IQ',
    'Asia/Bangkok': 'TH',
    'Asia/Beirut': 'LB',
    'Asia/Calcutta': 'IN',
    'Asia/Kolkata': 'IN',
    'Asia/Colombo': 'LK',
    'Asia/Damascus': 'SY',
    'Asia/Dubai': 'AE',
    'Asia/Gaza': 'PS',
    'Asia/Ho_Chi_Minh': 'VN',
    'Asia/Hong_Kong': 'HK',
    'Asia/Istanbul': 'TR',
    'Asia/Jakarta': 'ID',
    'Asia/Jerusalem': 'IL',
    'Asia/Kabul': 'AF',
    'Asia/Karachi': 'PK',
    'Asia/Kathmandu': 'NP',
    'Asia/Kuala_Lumpur': 'MY',
    'Asia/Kuwait': 'KW',
    'Asia/Manila': 'PH',
    'Asia/Riyadh': 'SA',
    'Asia/Seoul': 'KR',
    'Asia/Shanghai': 'CN',
    'Asia/Singapore': 'SG',
    'Asia/Taipei': 'TW',
    'Asia/Tehran': 'IR',
    'Asia/Tokyo': 'JP',
    'Atlantic/Azores': 'PT',
    'Atlantic/Cape_Verde': 'CV',
    'Atlantic/Canary': 'ES',
    'Atlantic/Reykjavik': 'IS',
    'Australia/Adelaide': 'AU',
    'Australia/Brisbane': 'AU',
    'Australia/Darwin': 'AU',
    'Australia/Lord_Howe': 'AU',
    'Australia/Melbourne': 'AU',
    'Australia/Perth': 'AU',
    'Australia/Sydney': 'AU',
    'Europe/Amsterdam': 'NL',
    'Europe/Athens': 'GR',
    'Europe/Berlin': 'DE',
    'Europe/Brussels': 'BE',
    'Europe/Copenhagen': 'DK',
    'Europe/Dublin': 'IE',
    'Europe/Helsinki': 'FI',
    'Europe/Istanbul': 'TR',
    'Europe/Kiev': 'UA',
    'Europe/Lisbon': 'PT',
    'Europe/London': 'GB',
    'Europe/Madrid': 'ES',
    'Europe/Moscow': 'RU',
    'Europe/Oslo': 'NO',
    'Europe/Paris': 'FR',
    'Europe/Prague': 'CZ',
    'Europe/Rome': 'IT',
    'Europe/Stockholm': 'SE',
    'Europe/Warsaw': 'PL',
    'Pacific/Auckland': 'NZ',
    'Pacific/Chatham': 'NZ',
    'Pacific/Honolulu': 'US',
    'Pacific/Fiji': 'FJ',
};

export {timezoneToCountryCode};